import { CircleSkeleton, ImageSkeleton, RectangleSkeleton, SquareSkeleton } from './Skeleton';

export {
  CircleSkeleton, ImageSkeleton, RectangleSkeleton,
  SquareSkeleton
};
